<article fxLayout="row" class="w-100 h-100">
    <section fxLayout="column" fxLayoutAlign="flex-end center" class="sen-login-image pb-5" fxFlex="1 1 50%">
        <div fxLayout="row" fxLayoutAlign="space-between center"
            class="position-relative px-5 py-2 text-white sen-login-info">
            <span fxFlex="1 1 70%">{{translate.getLng('LOGIN_HINT2')}}</span>
            <span class="sen-info-icon">i</span>
        </div>
    </section>
    <section class="sen-login sen-light-blue-bg px-5 py-4" fxLayout="column" fxFlex="1 1 50%"
        fxLayoutAlign="space-between center">
        <img class="mt-4" src="{{imagePath.loginSENLogo}}">
        <h2 class="my-4"><b>{{translate.getLng('LOGIN')}}</b></h2>
        <p class="mb-3">{{translate.getLng('LOGIN_HINT1')}}</p>
        <form [formGroup]="form" fxFlex="1 1 auto" class="w-75 example-form text-center">
            <mat-card class="sen-form-field-wrapper mb-4">
                <mat-form-field class="w-100" appearance="none">
                    <mat-label>{{translate.getLng('USERNAME')}}</mat-label>
                    <mat-icon matPrefix>account_box</mat-icon>
                    <input formControlName="sUsername" matInput autocomplete="off" type="text">
                </mat-form-field>
            </mat-card>
            <mat-card class="sen-form-field-wrapper mb-3">
                <mat-form-field class="w-100" appearance="none">
                    <mat-label>{{translate.getLng('PASSWORD')}}</mat-label>
                    <mat-icon matPrefix>lock</mat-icon>
                    <input matInput formControlName="sPassword" [type]="showPW ? 'text' : 'password'"
                        autocomplete="off">
                    <mat-icon class="sen-cursor-pointer" matSuffix (click)="showPW = !showPW">remove_red_eye</mat-icon>
                </mat-form-field>
            </mat-card>
            <div class="mb-4 mx-3" fxLayout="row" fxLayoutAlign="space-between center">
                <span>
                    <mat-checkbox></mat-checkbox> {{translate.getLng('REMEMBER_LOGIN')}}
                </span>
                <span (click)="passwordRequest()" class="sen-cursor-pointer">{{translate.getLng('ACC_FORGOT')}}</span>
            </div>
            <button (click)="login()" class="w-100 px-2 py-2" mat-raised-button color="primary"
                [routerLink]="[projectPath]">
                <mat-icon>login</mat-icon>
                <h4 class="d-inline ml-3">{{translate.getLng('LOGIN')}}</h4>
            </button>
        </form>
        <p>{{global.sCopyright}}</p>
    </section>
</article>